import { CreateVideoAndInitiateUploadDto } from '@greco/videos';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';

export class CreateEventVideoAndInitiateUploadDto extends CreateVideoAndInitiateUploadDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  eventId: string;
}
